import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { CaesarComponent } from '../caesar/caesar.component';
import { InputFieldComponent } from '../input-field/input-field.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { CryptoService } from '../crypto.service';
import { AtbashComponent } from '../atbash/atbash.component';
import { CryptoView } from '../crypto-view';

@Component({
  selector: 'app-discover',
  templateUrl: './discover.component.html',
  styleUrls: ['../topic-style.css','./discover.component.css']
})
export class DiscoverComponent extends GeneralExerciseComponent {

  @ViewChild('caesar', {static: true})
  private caesar: CaesarComponent;
  
  @ViewChild('atbash', {static: true})
  private atbash: AtbashComponent;

  private view: CryptoView;

  @ViewChild('inputField', {static: true})
  private inputField: InputFieldComponent;

  plainText: string;
  cipherText: string;
  method: string;
  keyP: any;

  hints: any[];

  dPlainText: string[];

  caretPos: number = 0;
  positionLetter: string;

  errors: number[] = [];
  tipCount: number = 1;

  selectedHint: number = 0;
  selectedChar: number = 0;


  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService, protected cryptoService: CryptoService) {
    super(activatedRoute, topicService, messageService);
  }

  setTypeSpecificsFromConfiguration() {
    this.plainText = this.configuration.typespecifics.text;
    this.dPlainText = this.plainText.split("");
    this.cipherText = this.plainText.replace(/[A-z]/gi, "-");
    this.method = this.configuration.typespecifics.method;
    this.keyP = this.configuration.typespecifics.key;
    this.positionLetter = this.plainText.charAt(0);
    let temphints = this.configuration.typespecifics.hints;
    this.hints = [];
    for(let hint of temphints){
      this.hints.push({
        plain: hint,
        cipher: this.cryptoService.encode(this.method, this.keyP, hint)
      });
    }
    switch(this.method){
      case "caesar": this.view = this.caesar; break;
      case "atbash": this.view = this.atbash; break;
    }
    this.caretPos = 0;
    this.onEmit(this.caretPos);
    if (this.view) {
      this.view.resetmapping();
    }
    this.tipCount = 1;
    this.selectedChar = 0;
    this.selectedHint = 0;
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecifics) {
      if (this.state.typespecifics.cipherText) {
        this.cipherText = this.state.typespecifics.cipherText;
      }
      if (this.state.typespecifics.mapping) {
        this.view.setmapping(this.state.typespecifics.mapping);
      }
      if(this.state.typespecifics.tipCount){
        this.tipCount = this.state.typespecifics.tipCount;
      }
    }
  }

  computeState() {
    this.cipherText = this.inputField.getText();
    this.state.typespecifics = {};
    this.state.typespecifics.cipherText = this.cipherText;
    this.state.typespecifics.mapping = this.view.getMapping();
    this.state.typespecifics.tipCount = this.tipCount;
  }

  checkSolution() {
    let solution = this.cryptoService.encode(this.method, this.keyP, this.plainText);
    this.cipherText = this.inputField.getText();
    this.errors = solution.split("").map((v,i) => [v,this.cipherText.charAt(i),i]).filter(v => v[0] != v[1]).map(v=>+v[2]);
    if(this.errors.length > 0){
      this.messageService.addAlertWithTimeout(this.get("notCorrectlyEncoded"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correctlyEncoded"), "success", 10000);
      this.solved = true;
      this.state.solved=true;
      this.saveState();
    }
   }

   evaluate(): number[] { 
    let solution = this.cryptoService.encode(this.method, this.keyP, this.plainText);
    this.cipherText = this.inputField.getText();
    let errors = solution.split("").map((v,i) => [v,this.cipherText.charAt(i),i]).filter(v => v[0] != v[1]).map(v=>+v[2]);
    let result = [3 - (errors.length)/20, 3];
    return result;
  }

  /** show additional tip */
  incrementTip(){
    if(this.tipCount < this.hints.length){
      this.tipCount++;
    }
  }

  /** when the ciphertext changes, compute the highlighted letter */
  onEmit(event){
    this.caretPos = event;
    this.positionLetter = this.plainText.charAt(this.caretPos);
  }



}
